import { render, staticRenderFns } from "./PublisherInformationCard.vue?vue&type=template&id=2d717798&scoped=true"
import script from "./PublisherInformationCard.vue?vue&type=script&lang=js"
export * from "./PublisherInformationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d717798",
  null
  
)

export default component.exports